import { Injectable } from '@angular/core';
import { ArcElement, Chart, DoughnutController, Legend, Title, Tooltip } from 'chart.js';
import { ChartDataInput } from '../shared/doughnut-chart/doughnut-chart.component';
import { GroupPage } from '../types';

Chart.register(DoughnutController, Title, Legend, ArcElement, Tooltip);

@Injectable({
  providedIn: 'root',
})
export class ChartService {
  constructor() {}

  groupChartExpected(groupPage: GroupPage, groupId?: string): ChartDataInput[] {
    if (!groupId || groupId === 'undefined') {
      // `budgeted.BUDGET` already omits buckets excluded from spending reports —
      // the server serializer applies the setting when it builds the map.
      return [...groupPage.data]
        .sort((a, b) => b.budgeted.BUDGET - a.budgeted.BUDGET)
        .map(c => ({ label: c.name, amount: c.budgeted.BUDGET }));
    }

    const group = groupPage.data.find(c => c.id === groupId);
    if (!group) return [];
    return [...group.buckets]
      .filter(bucket => bucket.type === 'BUDGET' && !bucket.excludedFromSpendingReports)
      .sort((a, b) => b.amount - a.amount)
      .map(c => ({ label: c.name, amount: c.amount }));
  }

  groupChartActual(groupPage: GroupPage, groupId?: string): ChartDataInput[] {
    if (!groupId || groupId === 'undefined') {
      return [...groupPage.data]
        .sort((a, b) => a.balance.BUDGET - b.balance.BUDGET)
        .filter(c => c.balance.BUDGET <= 0)
        .map(c => ({ label: c.name, amount: Math.abs(c.balance.BUDGET) }));
    }

    const group = groupPage.data.find(c => c.id === groupId);
    if (!group) return [];
    return [...group.buckets]
      .sort((a, b) => a.total - b.total)
      .filter(b => b.type === 'BUDGET' && !b.excludedFromSpendingReports && b.total <= 0)
      .map(c => ({ label: c.name, amount: Math.abs(c.total) }));
  }
}
